import React from 'react';
import { Tag } from 'antd';
import { CheckableTagProps } from 'antd/lib/tag/CheckableTag';

export type { CheckableTagProps };

const ProCheckableTag: React.FC<CheckableTagProps> = (props) => {
  const { children, ...resProps } = props;

  return <Tag.CheckableTag {...resProps}>{children}</Tag.CheckableTag>;
};

export default ProCheckableTag;
